<div class="container p-2">
  <div class="mat-dialog-content" *ngIf="userCustomer">
    <p>Are you sure you want to change Customer</p>
  </div>
  <div class="mat-dialog-content" *ngIf="!userCustomer">
    <p>Are you sure you want to change Corporate</p>
  </div>
  <div class="flex_container" mat-dialog-actions>
    <button class="ex2 btn-btn-danger" mat-button (click)="Cancle()">
      Cancel
    </button>
    <button
      class="ex1"
      [class.spinner]="loading"

      mat-buttonn
      mat-dialog-close
      (click)="userTypeChanged()"
    >
      OK
    </button>
  </div>
</div>
